import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { GroupPrincipal } from '../models';
import { groupQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class GroupRepositoryService extends RepositoryService<GroupPrincipal> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, groupQueries.selectAll);
  }
}
